import axios from "axios";
import { adnPageSize } from "../components/common/GeneralConfigurations";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";

const EmployeeCertificationApiUrl = `${baseApiUrl}/api/EmployeeCertification`;

export async function getEmployeeCertificationById(id) {
  return await httpRequest(fetchEmployeeCertificationById.bind(this, id));
}
async function fetchEmployeeCertificationById(id) {
  let config = getHttpHeaders();
  return await axios.get(`${EmployeeCertificationApiUrl}/${id}`, config);
}

export async function getEmployeeCertificationByEmployeeId(
  employeeId,
  orderBy = "",
  pageNumber = 1
) {
  return await httpRequest(
    fetchEmployeeCertificationByEmployeeId.bind(
      this,
      employeeId,
      orderBy,
      pageNumber,
      adnPageSize
    )
  );
}

async function fetchEmployeeCertificationByEmployeeId(
  employeeId,
  orderBy,
  pageNumber,
  adnPageSize
) {
  let config = getHttpHeaders();
  return await axios.get(
    `${EmployeeCertificationApiUrl}/Employee/${employeeId}?EmployeeId=${employeeId}&OrderBy=${orderBy}&PageNumber=${pageNumber}&PageSize=${adnPageSize}`,
    config
  );
}

export async function addEmployeeCertification(newEmployeeCertification) {
  return await httpRequest(
    postEmployeeCertification.bind(this, newEmployeeCertification)
  );
}

async function postEmployeeCertification(newEmployeeCertification) {
  let config = getHttpHeaders();
  return await axios.post(
    `${EmployeeCertificationApiUrl}`,
    newEmployeeCertification,
    config
  );
}

export async function updateEmployeeCertification(certification) {
  return await httpRequest(putEmployeeCertification.bind(this, certification));
}

async function putEmployeeCertification(certification) {
  let config = getHttpHeaders();
  return await axios.put(
    `${EmployeeCertificationApiUrl}`,
    certification,
    config
  );
}

export async function deleteEmployeeCertification(id) {
  return await httpRequest(fetchDeleteEmployeeCertification.bind(this, id));
}

async function fetchDeleteEmployeeCertification(id) {
  let config = getHttpHeaders();
  return await axios.delete(`${EmployeeCertificationApiUrl}/${id}`, config);
}

export async function sendCertificationEmail(certificationEmail) {
  return await httpRequest(
    putCertificationEmail.bind(this, certificationEmail)
  );
}

async function putCertificationEmail(certificationEmail) {
  let config = getHttpHeaders();
  return await axios.put(
    `${EmployeeCertificationApiUrl}/SendCertification`,
    certificationEmail,
    config
  );
}
